import { Tooltip, Link } from "@mui/material";
import React from "react";

export const MissionHoverView = ({ time, description, title, url }) => {
  return (
    <Tooltip
      title={`${description} (${time} Mins)`}
      placement="bottom-start"
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "14px",
          },
        },
      }}
    >
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href={url}
        sx={{
          textTransform: "capitalize",
          cursor: "pointer",
          textDecoration: "none",
          color: "rgba(0, 0, 0, 0.87)",
        }}
      >
        {title}
      </Link>
    </Tooltip>
  );
};
